import { wrapRequest } from '@applandeo/api-wrapper';
import { useEffect, useState } from 'react';

import ProfilePicture, { IProfilePictureProps } from '@/components/common/ProfilePicture/ProfilePicture';
import { getUserPicture } from '@/dataExchange/services/user.service';
import { ProfilePictureType } from '@/domain/user';

type AsyncProfilePictureProps = {
    size?: string;
    profilePictureUrl?: string | null;
} & Omit<IProfilePictureProps, 'profilePicture'>;

const AsyncProfilePicture = ({ size, profilePictureUrl, ...props }: AsyncProfilePictureProps) => {
    const getUserPictureRequest = wrapRequest(getUserPicture);
    const [profilePicture, setProfilePicture] = useState<ProfilePictureType>('');

    useEffect(() => {
        getUserPictureRequest.fetch(profilePictureUrl).onSuccess(response => {
            response && setProfilePicture(response);
        });
    }, []);

    return <ProfilePicture size={size ?? '2.5rem'} profilePicture={profilePicture} {...props} />;
};

export default AsyncProfilePicture;
